/* eslint-disable import/no-anonymous-default-export */
export default(locationData=[],action)=>{
    switch (action.type) {
        case 'ALL_LOCATION_DATA':
            return action.payload
        default:
            return locationData;
    }
}